/**
 * 当前页全选 / 取消全选：只增删本页 key，保留其它页已选（跨页多选）。
 * @param {Iterable<string|number>} prev
 * @param {Array<string|number>} pageKeys
 * @param {boolean} allSelected 当前页是否已全选
 * @returns {Set<string|number>}
 */
export function togglePageSelection(prev, pageKeys, allSelected) {
  const next = new Set(prev);
  const keys = Array.isArray(pageKeys) ? pageKeys : [];
  if (allSelected) {
    keys.forEach((key) => next.delete(key));
  } else {
    keys.forEach((key) => {
      if (key != null && key !== '') next.add(key);
    });
  }
  return next;
}

/**
 * 页码按钮序列（含省略号标记），与运营台分页展示一致。
 * @returns {Array<number|string>}
 */
export function buildSheinOpsPagerItems(currentPage, totalPages) {
  const total = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(Math.max(1, Number(currentPage) || 1), total);

  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const items = [1];
  let start = Math.max(2, current - 1);
  let end = Math.min(total - 1, current + 1);

  if (current <= 3) {
    start = 2;
    end = 5;
  } else if (current >= total - 2) {
    start = total - 4;
    end = total - 1;
  }

  if (start > 2) items.push('ellipsis-left');
  for (let page = start; page <= end; page += 1) items.push(page);
  if (end < total - 1) items.push('ellipsis-right');
  items.push(total);

  return items;
}
